import httpClient from '../../config/http.client'

const loginPost = (url, body) => httpClient.getInstance().post(url, body)

export default loginPost
